export default function StatCard({ title, value, icon: Icon, hint, testId }) {
  return (
    <div
      data-testid={testId}
      className="rounded-lg border border-border/60 bg-card p-5 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-sm"
    >
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{title}</p>
        {Icon && <Icon size={18} className="text-muted-foreground" />}
      </div>
      <p className="mt-2 font-heading text-2xl font-bold tabular-nums tracking-tight">{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
